import { useState, useEffect } from "react";
import {
  MdDashboard,
  MdPeople,
  MdOutlineBusinessCenter,
  MdLanguage,
  MdPassword,
  MdTag,
  MdDomainVerification,
  MdLocationCity,
} from "react-icons/md";
import PersonIcon from "@mui/icons-material/Person";
import FeedIcon from "@mui/icons-material/Feed";
import SkipPreviousIcon from "@mui/icons-material/SkipPrevious";
import SourceIcon from "@mui/icons-material/Source";
import InventoryIcon from "@mui/icons-material/Inventory";
import BallotIcon from "@mui/icons-material/Ballot";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import DnsIcon from "@mui/icons-material/Dns";
import { BiLogOutCircle } from "react-icons/bi";
import { Link } from "react-router-dom";
import SidebarMenu from "./SidebarMenu";
import "../../../style.min.css";
import { useUserAuth } from "../../context/UserAuthContext";
import { Help } from "@mui/icons-material";
import ImageIcon from "@mui/icons-material/Image";
import axios from "axios";
import { toast } from "react-toastify";
// new icons Added
const Sidenavbar = ({ closeSidebar }) => {
  const { language, setLanguage, user, token } = useUserAuth();
  const merchant_id = user.uid;
  const base_url = import.meta.env.VITE_LOCAL_BASE_URL;
  const [merchant, setMerchant] = useState([]);
  console.log('merchant',merchant)
  useEffect(() => {
    const getSingleDocumentHandler = async () => {
      if (!merchant_id) return;
      try {
        const [merchantRes] = await Promise.all([
          axios.get(`${base_url}/api/v1/users/id/${merchant_id}`, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }),
        ]);
        setMerchant(merchantRes.data.data);
      } catch (error) {
        console.error("Error fetching data:", error);
        toast.error("Failed to load required data");
      }
    };
    getSingleDocumentHandler();
  }, [merchant_id]);

  const langHandler = () => {
    language === "en" ? setLanguage("hi") : setLanguage("en");
    closeSidebar();
  };

  const [windowDimension, setWindowDimension] = useState(window.innerWidth);
  const [isOpen, setIsOpen] = useState(true);

  const detectSize = () => {
    setWindowDimension(window.innerWidth);
    if (windowDimension < 768) {
      setIsOpen(false);
    } else {
      setIsOpen(true);
    }
  };
  useEffect(() => {
    if (windowDimension < 768) {
      setIsOpen(false);
    }
    window.addEventListener("resize", detectSize);
    return () => {
      window.removeEventListener("resize", detectSize);
    };
  }, [windowDimension]);
  const filterd_path =
    merchant?.category_id === "trvwyuvRqNTuZQh8KNbi"
      ? "/dashboard/venue-previous-work"
      : "/dashboard/previous-work";

  const [item, setItem] = useState([])
  useEffect(() => {
    setItem([
      {
        title: `Profile Management`,
        hindiTitle: `प्रोफाइल मैनेजमेंट`,
        color: "rgb(28, 115, 151)",
        icon: <MdPeople size={20} className='my__nav__icon' color='#fff' />,
        dropDown: [
          {
            title: `Profile`,
            hindiTitle: "प्रोफाइल",
            icon: <PersonIcon className='my__nav__icon' color='#fff' />,
            href: 'profile'
          },
          {
            title: "Basic Details",
            hindiTitle: "सामान्य जानकारी",
            icon: <FeedIcon className='my__nav__icon' color='#000' />,
            href: 'basic-detail'
          },
          {
            title: "Add Business Photos",
            hindiTitle: "व्यवसाय का फोटो डालें",
            icon: <ImageIcon className='my__nav__icon' color='#000' />,
            href: filterd_path
          },
          {
            title: "Things To Know",
            hindiTitle: "जानने योग्य जानकारी",
            icon: <SourceIcon className='my__nav__icon' color='#000' />,
            href: 'thinks-to-know'
          },

          {
            title: "Add Product/Service",
            hindiTitle: "वस्तु या सर्विसेज दर्शाये",
            icon: <InventoryIcon className='my__nav__icon' color='#000' />,
            href: 'add-product'
          },
          {
            title: "Products/Services List",
            hindiTitle: "प्रोडक्ट/सर्विस लिस्ट",
            icon: <BallotIcon className='my__nav__icon' color='#000' />,
            href: 'product-list'
          },
        ]
      },
      {
        title: "Bundle Package",
        hindiTitle: `बंडल पैकेज`,
        icon: <MdOutlineBusinessCenter size={20} className='my__nav__icon' color='#fff' />,
        color: "rgb(28, 115, 151)",
        dropDown: [
          {
            title: "Add Package",
            hindiTitle: `नया पैकेज बनाएं`,
            icon: <LocalOfferIcon className='my__nav__icon' color='#fff' />,
            href: 'create-package'
          },
          {
            title: "All Package",
            hindiTitle: `अपने पैकेज देखें`,
            icon: <DnsIcon className='my__nav__icon' color='#fff' />,
            href: 'bundle-package'
          }
        ]
      },
    ])
  }, [filterd_path])

  const [withoutPkg, setWithoutPkg] = useState([
    {
      title: `Profile Management`,
      hindiTitle: `प्रोफाइल मैनेजमेंट`,
      color: "#0a0a0a",
      icon: <MdPeople size={20} className="my__nav__icon" color="#fff" />,
      dropDown: [
        {
          title: `Profile`,
          hindiTitle: "प्रोफाइल",
          icon: <PersonIcon className="my__nav__icon" color="#fff" />,
          href: "profile",
        },
        {
          title: "Basic Details",
          hindiTitle: "सामान्य जानकारी",
          icon: <FeedIcon className="my__nav__icon" color="#000" />,
          href: "basic-detail",
        },
        {
          title: "Add Business Photos",
          hindiTitle: "व्यवसाय का फोटो डालें",
          icon: <SkipPreviousIcon className="my__nav__icon" color="#000" />,
          href: "previous-work",
        },
        {
          title: "Things To Know",
          hindiTitle: "जानने योग्य जानकारी",
          icon: <SourceIcon className="my__nav__icon" color="#000" />,
          href: "thinks-to-know",
        },

        {
          title: "Add Product/Service",
          hindiTitle: "वस्तु या सर्विसेज दर्शाये",
          icon: <InventoryIcon className="my__nav__icon" color="#000" />,
          href: "add-product",
        },
        {
          title: "Products/Services List",
          hindiTitle: "प्रोडक्ट/सर्विस लिस्ट",
          icon: <BallotIcon className="my__nav__icon" color="#000" />,
          href: "product-list",
        },
      ],
    },
  ]);
  return (
    <aside className="left-sidebar" data-sidebarbg="skin5">
      {/* <!-- Sidebar scroll--> */}
      <div className="scroll-sidebar">
        {/* <!-- Sidebar navigation--> */}
        <nav className="sidebar-nav">
          <ul id="sidebarnav" className="pt-4">
            <li className="sidebar-item">
              <Link
                className="sidebar-link waves-effect waves-dark sidebar-link"
                to="dash_board"
                onClick={closeSidebar}
                aria-expanded="false"
              >
                <div
                  className="sidebar d-flex justify-content-between align-items-center"
                  style={{
                    height: "30px",
                    width: "30px",
                    backgroundColor: "#0a0a0a",
                    borderRadius: "50%",
                    marginRight: "5px",
                  }}
                >
                  <MdDashboard
                    size={20}
                    style={{
                      display: "inline-block",
                      textAlign: "center",
                      width: "35px",
                      color: "#fff",
                    }}
                  />
                </div>
                <span className="hide-menu">
                  {" "}
                  {language === "en" ? `Dashboard` : `मुख्य पेज`}
                </span>
              </Link>
            </li>
              <li className="sidebar-item">
              <Link
                className="sidebar-link waves-effect waves-dark sidebar-link"
                to="/dashboard/services"
                aria-expanded="false"
                onClick={closeSidebar}
              >
                <div
                  className="sidebar d-flex justify-content-between align-items-center"
                  style={{
                    height: "30px",
                    width: "30px",
                    backgroundColor: "#0a0a0a",
                    borderRadius: "50%",
                    marginRight: "5px",
                    display: "flex !important",
                    justifyContent: "center !important",
                  }}
                >
                  <MdPassword
                    size={18}
                    className="my__nav__icon"
                    style={{
                      display: "inline-block",
                      textAlign: "center",
                      width: "30px",
                      color: "#fff",
                    }}
                  />
                </div>
                <span className="hide-menu">
                  {language === "en"
                    ? `Services`
                    : `सेवाएं`}
                </span>
              </Link>
            </li>
                <li className="sidebar-item">
              <Link
                className="sidebar-link waves-effect waves-dark sidebar-link"
                to="/dashboard/lead-dashboard"
                aria-expanded="false"
                onClick={closeSidebar}
              >
                <div
                  className="sidebar d-flex justify-content-between align-items-center"
                  style={{
                    height: "30px",
                    width: "30px",
                    backgroundColor: "#0a0a0a",
                    borderRadius: "50%",
                    marginRight: "5px",
                    display: "flex !important",
                    justifyContent: "center !important",
                  }}
                >
                  <MdPassword
                    size={18}
                    className="my__nav__icon"
                    style={{
                      display: "inline-block",
                      textAlign: "center",
                      width: "30px",
                      color: "#fff",
                    }}
                  />
                </div>
                <span className="hide-menu">
                  {language === "en"
                    ? `Leads`
                    : `बुकिंग`}
                </span>
              </Link>
            </li>
            <li className="sidebar-item">
              <Link
                className="sidebar-link waves-effect waves-dark sidebar-link"
                to="/dashboard/total-reviews"
                aria-expanded="false"
                onClick={closeSidebar}
              >
                <div
                  className="sidebar d-flex justify-content-between align-items-center"
                  style={{
                    height: "30px",
                    width: "30px",
                    backgroundColor: "#0a0a0a",
                    borderRadius: "50%",
                    marginRight: "5px",
                    display: "flex !important",
                    justifyContent: "center !important",
                  }}
                >
                  <MdPassword
                    size={18}
                    className="my__nav__icon"
                    style={{
                      display: "inline-block",
                      textAlign: "center",
                      width: "30px",
                      color: "#fff",
                    }}
                  />
                </div>
                <span className="hide-menu">
                  {language === "en"
                    ? `Review`
                    : `समीक्षा`}
                </span>
              </Link>
            </li>
            <li className="sidebar-item">
              <Link
                className="sidebar-link waves-effect waves-dark sidebar-link"
                to="/dashboard/packages"
                aria-expanded="false"
                onClick={closeSidebar}
              >
                <div
                  className="sidebar d-flex justify-content-between align-items-center"
                  style={{
                    height: "30px",
                    width: "30px",
                    backgroundColor: "#0a0a0a",
                    borderRadius: "50%",
                    marginRight: "5px",
                    display: "flex !important",
                    justifyContent: "center !important",
                  }}
                >
                  <MdTag
                    size={18}
                    className="my__nav__icon"
                    style={{
                      display: "inline-block",
                      textAlign: "center",
                      width: "30px",
                      color: "#fff",
                    }}
                  />
                </div>
                <span className="hide-menu">
                  {" "}
                  {language === "en" ? `Packages` : `पैकेज`}
                </span>
              </Link>
            </li>
            <li className="sidebar-item">
              <Link
                className="sidebar-link waves-effect waves-dark sidebar-link"
                to="/dashboard/change-password"
                aria-expanded="false"
                onClick={closeSidebar}
              >
                <div
                  className="sidebar d-flex justify-content-between align-items-center"
                  style={{
                    height: "30px",
                    width: "30px",
                    backgroundColor: "#0a0a0a",
                    borderRadius: "50%",
                    marginRight: "5px",
                    display: "flex !important",
                    justifyContent: "center !important",
                  }}
                >
                  <MdPassword
                    size={18}
                    className="my__nav__icon"
                    style={{
                      display: "inline-block",
                      textAlign: "center",
                      width: "30px",
                      color: "#fff",
                    }}
                  />
                </div>
                <span className="hide-menu">
                  {language === "en"
                    ? `Change Password`
                    : `पासवर्ड बदलें`}
                </span>
              </Link>
            </li>
            <li className="sidebar-item">
              <Link
                className="sidebar-link waves-effect waves-dark sidebar-link"
                to="/dashboard/help"
                aria-expanded="false"
                onClick={closeSidebar}
              >
                <div
                  className="sidebar d-flex justify-content-between align-items-center"
                  style={{
                    height: "30px",
                    width: "30px",
                    backgroundColor: "#0a0a0a",
                    borderRadius: "50%",
                    marginRight: "5px",
                    display: "flex !important",
                    justifyContent: "center !important",
                  }}
                >
                  <Help
                    size={18}
                    className="my__nav__icon"
                    style={{
                      display: "inline-block",
                      textAlign: "center",
                      width: "30px",
                      color: "#fff",
                    }}
                  />
                </div>
                <span className="hide-menu">
                  {" "}
                  {language === "en" ? `Help` : `सहायता`}
                </span>
              </Link>
            </li>
            {
              merchant?.country_id === "4Dj1nUEkp4vFOh4HI0CL" && (
<li className="sidebar-item">
              <Link
                className="sidebar-link waves-effect waves-dark sidebar-link"
                to="/dashboard/profile-kyc"
                aria-expanded="false"
                onClick={closeSidebar}
              >
                <div
                  className="sidebar d-flex justify-content-between align-items-center"
                  style={{
                    height: "30px",
                    width: "30px",
                    backgroundColor: "rgb(28, 115, 151)",
                    borderRadius: "50%",
                    marginRight: "5px",
                    display: "flex !important",
                    justifyContent: "center !important",
                  }}
                >
                  <MdDomainVerification
                    size={18}
                    className="my__nav__icon"
                    style={{
                      display: "inline-block",
                      textAlign: "center",
                      width: "30px",
                      color: "#fff",
                    }}
                  />
                </div>
                <span className="hide-menu">
                  {" "}
                  {language === "en" ? `Profile KYC` : `अपने ग्राहक को जानें`}
                </span>
              </Link>
            </li>
              )
            }
             {
              merchant?.category_id === "trvwyuvRqNTuZQh8KNbi" && (
                <li className="sidebar-item">
              <Link
                className="sidebar-link waves-effect waves-dark sidebar-link"
                to="/dashboard/business-map"
                aria-expanded="false"
                onClick={closeSidebar}
              >
                <div
                  className="sidebar d-flex justify-content-between align-items-center"
                  style={{
                    height: "30px",
                    width: "30px",
                    backgroundColor: "rgb(28, 115, 151)",
                    borderRadius: "50%",
                    marginRight: "5px",
                    display: "flex !important",
                    justifyContent: "center !important",
                  }}
                >
                  <MdLocationCity
                    size={18}
                    className="my__nav__icon"
                    style={{
                      display: "inline-block",
                      textAlign: "center",
                      width: "30px",
                      color: "#fff",
                    }}
                  />
                </div>
                <span className="hide-menu">
                  {" "}
                  {language === "en" ? `Business Map` : `Business Map`}
                </span>
              </Link>
            </li>
              )
            }
            
            <li className="sidebar-item">
              <Link
                className="sidebar-link waves-effect waves-dark sidebar-link logout_btn"
                onClick={langHandler}
                aria-expanded="false"
              >
                <MdLanguage
                  size={18}
                  style={{
                    display: "inline-block",
                    textAlign: "center",
                    width: "35px",
                  }}
                />
                <span className="hide-menu">
                  {" "}
                  {language === "en" ? `Change Language` : `भाषा बदले`}
                </span>
              </Link>
            </li>
            <li className="sidebar-item">
              <Link
                className="sidebar-link waves-effect waves-dark sidebar-link logout_btn"
                to="/dashboard/logout"
                aria-expanded="false"
              >
                <BiLogOutCircle
                  size={18}
                  style={{
                    display: "inline-block",
                    textAlign: "center",
                    width: "35px",
                  }}
                />
                <span className="hide-menu">
                  {language === "en" ? `Logout` : `लॉगआउट`}
                </span>
              </Link>
            </li>
          </ul>
        </nav>
      </div>
    </aside>
  );
};

export default Sidenavbar;
